/**
 * TIM chrome — masthead collapse on scroll, gold nav stays pinned.
 *
 * Port of CS-Cart `tim-sticky-header.js` / CMS `TimMastheadCollapse`:
 *   - collapse once scrollY passes 80
 *   - restore ONLY when back within 48 of the top (hysteresis)
 *   - between thresholds, hold state
 *
 * Shopify structure matches CS-Cart: masthead (`.tim-chrome`) and gold nav
 * (`.shopify-section__header`) are separate sticky sections. Publishes
 * `--tim-masthead-h` + `--tim-chrome-height` from the masthead row height so
 * the gold nav can follow the collapse down to `top: 0`.
 */
(function () {
  'use strict';

  var COLLAPSED = 'is-masthead-collapsed';
  var COLLAPSE_AFTER_PX = 80;
  var EXPAND_NEAR_TOP_PX = 48;
  var MASTHEAD_H = '--tim-masthead-h';
  var CHROME_H = '--tim-chrome-height';
  var ANN_H = '--announcement-bar-height';

  function init() {
    var chrome = document.querySelector('.tim-chrome');
    var top = chrome && chrome.querySelector('.to-header__top');
    if (!chrome || !top || chrome.dataset.timCollapse) return;
    chrome.dataset.timCollapse = '1';

    var root = document.documentElement;
    var collapsed = root.classList.contains(COLLAPSED);

    function publishHeight() {
      /* Read the masthead row, not the section wrapper: once collapsed the
         sticky box may linger while the row inside goes to zero. */
      var h = Math.round(top.getBoundingClientRect().height) + 'px';
      root.style.setProperty(MASTHEAD_H, h);
      root.style.setProperty(CHROME_H, h);
      root.style.setProperty(ANN_H, h);
    }

    function setCollapsed(next) {
      if (next === collapsed) return;
      collapsed = next;
      root.classList.toggle(COLLAPSED, collapsed);
      if (collapsed) {
        top.setAttribute('inert', '');
        top.setAttribute('aria-hidden', 'true');
      } else {
        top.removeAttribute('inert');
        top.removeAttribute('aria-hidden');
      }
      publishHeight();
    }

    /* No rAF throttle — see CS-Cart tim-sticky-header.js (background-tab freeze). */
    function sync() {
      var y = window.scrollY || window.pageYOffset || 0;
      if (y <= EXPAND_NEAR_TOP_PX) setCollapsed(false);
      else if (y >= COLLAPSE_AFTER_PX) setCollapsed(true);
    }

    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', publishHeight);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        sync();
        publishHeight();
      }
    });

    if (window.ResizeObserver) new ResizeObserver(publishHeight).observe(top);

    publishHeight();
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify theme editor section reloads */
  document.addEventListener('shopify:section:load', init);
})();
